<template>
  <div class="tree-menu">
    <div class="label-wrapper" @click="toggleChildren">
      <div :class="labelClasses">
        <div class="row text-uppercase category-label font-weight-bold">
          <div :style="indent" :on="setCategory(this.category)">
            {{ label }}<i v-if="nodes.length > 0" :class="iconClasses"></i></i>
            <img src="/static/img/ic_freeworldmap.png" width="30px" v-if="this.category.osm" />
          </div>
        </div>
        <div class="row align-items-center my-offer" v-for="offer in offers">
          <div class="col col-1" style="padding: 0px;">
            <product-offer-icon v-bind:icon="offer.info.icon" height="36px"></product-offer-icon>
          </div>
          <div class="col col-1" style="padding: 0px;margin-right:5px;border:0px solid gray;">
            <small><router-link :to="{ name: 'Offer', params: {id: offer.info.id} }">{{offer.info.id}}</router-link></small>
          </div>
          <div class="col col-5 font-weight-bold" style="padding: 0px;font-size: 1em;border:0px solid gray;">
            {{offer.info.name}}
          </div>
          <div class="col col-1" style="padding: 0px;font-size: 1em;border:0px solid gray;">
            <i :class="hiddenClasses(offer.info.visibility)"></i>
            <i :class="manageClasses(offer.info.manage)"></i>
            <i :class="suggestionClasses(offer.info.id)"></i>
            <i :class="previewsClasses(offer.info.previews)"></i>
          </div>
          <div class="col col-2" style="padding: 0px;border:0px solid gray;">
            <small>{{offer.info.size  | prettyBytes }}</small>
          </div>
          <div class="col col-1" style="padding: 0px;border:0px solid gray;">
            <div v-for="sale in offer.sale_options">
              <sale-option v-bind:codename="sale.codename" v-bind:duration="sale.duration"/>
            </div>
          </div>
        </div>
      </div>
    </div>
    <tree-menu
      v-if="showChildren"
      v-for="node in nodes"
      :nodes="node.sub_categories"
      :offers="node.product_offers"
      :category="node"
      :label="node.name"
      :depth="depth + 1"
      :key="node.index"
    >
    </tree-menu>
  </div>
</template>

<style>
  .tree-menu {
    color: #37474F;

    .label-wrapper {
      padding-bottom: 10px;
      margin-bottom: 10px;
      border-bottom: 1px solid #ccc;
      .has-children {
        cursor: pointer;
      }
    }
  }
  .my-offer {
    padding: 0.4rem 0.75rem 0.4rem 0.75rem;
    border-bottom: 1px solid #E0E0E0;
  }
  .category-label {
    padding: 1.5rem 0.75rem 1.5rem 0.75rem;
    border-bottom: 1px solid #E0E0E0;
    background-color: #EEEEEE;
  }
  .icon-arrow-down {
    margin-left: 10px;
    font-weight: bold;
  }
  .icon-arrow-right {
    margin-left: 10px;
    font-weight: bold;
  }
  .icon-ghost {
    color: #039BE5;
    font-weight: bold;
  }
  .icon-settings {
    color: #43A047;
    font-weight: bold;
  }
  .icon-rocket {
    color: #F57C00;
    font-weight: bold;
  }
  .icon-grid {
    color: #D81B60;
    font-weight: bold;
  }
</style>

<script>
import ProductOfferIcon from 'components/ProductOfferIcon'
import SaleOption from 'components/SaleOption'

export default {
  name: 'tree-menu',
  props: [ 'nodes', 'label', 'depth', 'offers', 'category' ],
  data () {
    return {
      showChildren: true,
      current_category: []
    }
  },
  computed: {
    iconClasses () {
      return {
        'icon-arrow-right': !this.showChildren,
        'icon-arrow-down': this.showChildren
      }
    },
    labelClasses () {
      return { 'has-children': this.nodes }
    },
    indent () {
      return { transform: `translate(${this.depth * 10}px)` }
    }
  },
  components: {
    ProductOfferIcon,
    SaleOption
  },
  methods: {
    toggleChildren () {
      this.showChildren = !this.showChildren
    },
    hiddenClasses (visibility) {
      if (visibility !== 'visible') {
        return { 'icon-ghost': true }
      }
    },
    manageClasses (manage) {
      return {
        'icon-settings': manage
      }
    },
    previewsClasses (previews) {
      if (previews.length > 0) {
        return { 'icon-grid': true }
      }
    },
    suggestionClasses (id) {
      var suggestions = this.hasSuggestions(this.current_category)
      if (suggestions.includes(id)) {
        return { 'icon-rocket': true }
      }
    },
    setCategory (cat) {
      this.current_category = cat
    },
    hasSuggestions (cat) {
      if (cat.suggestions) {
        var listSuggestions = cat.suggestions.map(function (suggestion) {
          return suggestion.product_offer_id
        })
        return listSuggestions
      }
    }
  }
}
</script>



// WEBPACK FOOTER //
// src/components/TreeMenu.vue